import { ACTIONS } from "../constants"


const initialState = {
  specialties: [],
  specialtie: {},
  totalSize: 0,
  isFetching: false,
  isLoading: false,
  hasMore: true,
  success: {
    isDeactivated: false,
    isActivated: false,
    isCreated: false,
    isUpdated: false,
    isDeleted: false,
  },
  error: null
}


export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {

    case ACTIONS.CLEAR_SPECIALTIES: {
      return { ...state, success: initialState.success, error: null, isFetching: false, isLoading: false }
    }

    case ACTIONS.FETCH_SPECIALTIES_INIT: {
      return { ...state, isFetching: true, error: null }
    }
    case ACTIONS.FETCH_SPECIALTIES_SUCCEDED: {
      const { count, results } = payload
      return { ...state, totalSize: count, specialtie: payload, isFetching: false, error: null }
    }
    case ACTIONS.FETCH_SPECIALTIES_FAILED: {
      return { ...state, isFetching: false, error: payload }
    }

    case ACTIONS.CREATE_SPECIALTIES_INIT: {
      return { ...state, isLoading: true, error: null, success: initialState.success }
    }
    case ACTIONS.CREATE_SPECIALTIES_SUCCEDED: {
      return { ...state, success: { ...state.success, isCreated: true }, isLoading: false, error: null }
    }
    case ACTIONS.CREATE_SPECIALTIES_FAILED: {
      return { ...state, error: payload, isLoading: false }
    }

    case ACTIONS.EDIT_SPECIALTIES_INIT: {
      return { ...state, isLoading: true, error: null, success: initialState.success }
    }
    case ACTIONS.EDIT_SPECIALTIES_SUCCEDED: {
      console.log({payload})
      return { ...state, success: { ...state.success, isUpdated: true }, specialtie: payload, isLoading: false, error: null }
    }
    case ACTIONS.EDIT_SPECIALTIES_FAILED: {
      return { ...state, error: payload, isLoading: false }
    }

    case ACTIONS.FETCH_SPECIALTIESS_INIT: {
      return { ...state, isLoading: true, success: initialState.success, specialties: null, error: null }
    }
    case ACTIONS.FETCH_SPECIALTIESS_SUCCEDED: {
      const { count, results } = payload
      // console.log(results)
      return { ...state,totalSize: count, specialties: results, isFetching: false, isLoading: false, error: null }
    }
    case ACTIONS.FETCH_SPECIALTIESS_FAILED: {
      return { ...state, isLoading: false, error: payload }
    }



    case ACTIONS.DEACTIVATE_SPECIALTIES_INIT: {
      return { ...state, isLoading: true, success: initialState.success, error: null }
    }
    case ACTIONS.DEACTIVATE_SPECIALTIES_SUCCEDED: {
      return { ...state, success: { ...state.success, isDeactivated: true }, isLoading: false, error: null }
    }
    case ACTIONS.DEACTIVATE_SPECIALTIES_FAILED: {
      return { ...state, isLoading: false, error: payload }
    }



    case ACTIONS.ACTIVATE_SPECIALTIES_INIT: {
      return { ...state, isLoading: true, success: initialState.success, error: null }
    }
    case ACTIONS.ACTIVATE_SPECIALTIES_SUCCEDED: {
      return { ...state, success: { ...state.success, isActivated: true }, isLoading: false, error: null }
    }
    case ACTIONS.ACTIVATE_SPECIALTIES_FAILED: {
      return { ...state, isLoading: false, error: payload }
    }



    case ACTIONS.DELETE_SPECIALTIES_INIT: {
      return { ...state, isLoading: true, success: initialState.success, error: null }
    }
    case ACTIONS.DELETE_SPECIALTIES_SUCCEDED: {
      return { ...state, success: { ...state.success, isDeleted: true }, isLoading: false, error: null }
    }
    case ACTIONS.DELETE_SPECIALTIES_FAILED: {
      return { ...state, isLoading: false, error: payload }
    }
    default: {
      return state
    }
  }
}
